// CSS Modules - component class name: Pagination__

<template>
  <form :class="$style.container">
    <div class="columns is-mobile">
      <div class="column is-half">
        <FormSelect
          :hasFilter="false"
          v-model="config.resultsSelect.initialSelectOption"
          :options="config.resultsSelect.selectOptions"
          :initialOption="config.resultsSelect.initialSelectOption"
          @input="updateResults(config.resultsSelect)"
        />
      </div>
      <div :class="[$style.pages, 'column is-half']">
        <span :class="$style.text">{{ config.texts.page }}</span>
        <FormSelect
          :hasFilter="false"
          v-model="initialPagesSelectOption"
          :options="pagesSelectOptions"
          :initialOption="initialPagesSelectOption"
          @input="updateCurrentPage"
        />
        <span :class="$style.text">{{ config.texts.of }} {{ pages }}</span>
        <input
          type="button"
          :disabled="currentPage === 1"
          :class="$style.previousButton"
          @click="updateCurrentPage(currentPage - 1)"
        />
        <input
          type="button"
          :disabled="currentPage === pages"
          :class="$style.nextButton"
          @click="updateCurrentPage(currentPage + 1)"
        />
      </div>
    </div>
  </form>
</template>

<script>
import FormSelect from "../FormSelect/FormSelect";

export default {
  name: "Pagination",
  components: {
    FormSelect
  },
  props: {
    results: {
      type: Number,
      default: null
    },
    config: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      pages: null,
      currentPage: 1,
      resultsPerPage: this.config.resultsPerPage,
      initialPagesSelectOption: "1",
      pagesSelectOptions: [],
      displayRange: [0, this.config.resultsPerPage - 1]
    };
  },
  methods: {
    updatePages() {
      this.currentPage = 1;
      this.initialPagesSelectOption = this.currentPage.toString();
      this.pages = Math.ceil(this.results / this.resultsPerPage);
      this.pagesSelectOptions = [];
      for (let i = 1; i < this.pages + 1; i++) {
        this.pagesSelectOptions.push(i.toString());
      }
      this.setDisplayRange();
    },
    setDisplayRange() {
      this.displayRange = [
        this.currentPage * this.resultsPerPage - this.resultsPerPage,
        this.currentPage * this.resultsPerPage - 1
      ];
      this.$emit("update", this.displayRange);
    },
    setDisplayRangeFromPageChange() {
      this.displayRange = [
        this.currentPage * this.resultsPerPage - this.resultsPerPage,
        this.currentPage * this.resultsPerPage - 1
      ];
      this.$emit("update", this.displayRange);
      this.$emit("forceUpdate");
    },
    updateResults(results) {
      const index = results.selectOptions.indexOf(results.initialSelectOption);
      if (index === 0) {
        this.resultsPerPage = this.config.resultsPerPage;
      } else if (index === 1) {
        this.resultsPerPage = this.config.resultsPerPage * 2;
      } else if (index === 2) {
        this.resultsPerPage = 999999;
      }
      this.updatePages();
    },
    updateCurrentPage(page) {
      this.currentPage = +page;
      this.initialPagesSelectOption = this.currentPage.toString();
      this.setDisplayRangeFromPageChange();
    }
  },
  watch: {
    results: function(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.updatePages();
      }
    }
  },
  mounted() {
    this.updatePages();
  }
};
</script>

<style module lang="scss">
@import "./Pagination.scss";
</style>
